import React from "react";
import { Activity } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../routes";

interface AdminUserActivityLinkProps {
  instructorId: string;
}

/** Opens the account's activation funnel and timeline. */
const AdminUserActivityLink: React.FC<AdminUserActivityLinkProps> = ({ instructorId }) => {
  const { t } = useTranslation();

  return (
    <Link
      to={ROUTES.ADMIN_USER_ACTIVITY.replace(":id", instructorId)}
      className="btn btn-secondary flex items-center gap-1.5"
    >
      <Activity size={16} />
      {t("admin.activity.title")}
    </Link>
  );
};

export default AdminUserActivityLink;
